var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_7526_17098",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 15.75C13.4779 15.75 16.5 12.7279 16.5 9C16.5 5.27208 13.4779 2.25 9.75 2.25C6.02208 2.25 3 5.27208 3 9C3 10.2301 3.32904 11.3834 3.90392 12.3765L3.33622 14.4952C3.18679 15.0529 3.6971 15.5632 4.25477 15.4138L6.37347 14.8461C7.36665 15.421 8.5199 15.75 9.75 15.75Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90392 12.3765L5.35281 12.7648L5.51387 12.1637L5.20213 11.6251L3.90392 12.3765ZM3.33622 14.4952L4.7851 14.8835L3.33622 14.4952ZM4.25477 15.4138L3.86655 13.9649H3.86655L4.25477 15.4138ZM6.37347 14.8461L7.1249 13.5479L6.58632 13.2361L5.98524 13.3972L6.37347 14.8461ZM15 9C15 11.8995 12.6495 14.25 9.75 14.25V17.25C14.3063 17.25 18 13.5563 18 9H15ZM9.75 3.75C12.6495 3.75 15 6.10051 15 9H18C18 4.44365 14.3063 0.75 9.75 0.75V3.75ZM4.5 9C4.5 6.10051 6.85051 3.75 9.75 3.75V0.75C5.19365 0.75 1.5 4.44365 1.5 9H4.5ZM5.20213 11.6251C4.75589 10.8542 4.5 9.95924 4.5 9H1.5C1.5 10.501 1.9022 11.9125 2.60571 13.128L5.20213 11.6251ZM4.7851 14.8835L5.35281 12.7648L2.45503 11.9883L1.88733 14.107L4.7851 14.8835ZM3.86655 13.9649C4.42422 13.8155 4.93453 14.3258 4.7851 14.8835L1.88733 14.107C1.43904 15.78 2.96997 17.311 4.643 16.8627L3.86655 13.9649ZM5.98524 13.3972L3.86655 13.9649L4.643 16.8627L6.76169 16.295L5.98524 13.3972ZM9.75 14.25C8.79076 14.25 7.89584 13.9941 7.1249 13.5479L5.62204 16.1443C6.83745 16.8478 8.24903 17.25 9.75 17.25V14.25Z",
    fill: "#939393",
    mask: "url(#path-1-inside-1_7526_17098)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.a96e6fb5d27e9172c433aba398df07c9.svg";
export { ForwardRef as ReactComponent };